import React from 'react';
import { useParams } from 'react-router-dom';
import UpiAtmInvoice from './upiAtmInvoice';

function UpiAtmInvoicePage() {
  const { transactionId } = useParams();

  return (
    <div>
      <div className="content-wrapper pt-2">
        <div className="content-header my-0 py-0">
          <div className="container-fluid">
            <div className="row mb-0 align-items-center">
              <div className="col-sm-6">
                <h1 className='page-title text-blue font-merriweather'>
                  UPI QR <span className='text-red'>Invoice</span>
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="container-fluid pt-2 pb-5">
            <UpiAtmInvoice isPageView={true} transactionId={transactionId} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpiAtmInvoicePage;